import { EventEmitter, Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ModuleStateService {

  public guid: string = '';
  public docId: string = '';
  public path: string = '';
  public sideDocInfo: any = { sideDocId: '', sideDocType: '', sideDocName: '' }

  public onAccessListLoaded = new EventEmitter<any>();
  public onSimpleCredentialsLoaded = new EventEmitter();

  public startFromRoot: WritableSignal<boolean> = signal(false);

  constructor() { }

  gotoRootPageByRole(role: string, path: string): string {
    let redirectUri;
    if (path) {
      redirectUri = path;
    } else {
      switch (role) {
        case '':
          redirectUri = '/user-desktop';
          break;
        case 'anastasis':
          redirectUri = '/admin-page';
          break;
        case 'admin':
          redirectUri = '/admin-page';
          break;
        default:
          redirectUri = '/user-desktop';
          break;
      }
    }
    return redirectUri;
  }


  public goToWebsiteClick(from: string, type: string) {
    if (type === 'private') {
      if (from === 'order-list') {
        // order-list
        // console.log('+++++https://www.anastasis.it/supermappex-privati');
        window.open('https://www.anastasis.it/prodotti/smx-studio/', '_blank');
      } else if (from === 'invalid-credentials') {
        // invalid-credentials
        // console.log('+++++https://www.anastasis.it/supermappex-privati-info');
        window.open('https://www.anastasis.it/prodotti/smx-studio/', '_blank');
      }
    } else if (type === 'school') {
      // console.log('+++++https://www.anastasis.it/supermappex-scuole');
      window.open('https://www.anastasis.it/prodotti/smx-studio/#scuola', '_blank');
    }
  }
}

